module.exports = __webpack_public_path__ + "static/media/6730.37d249d8.jpg";